import React, { lazy } from 'react';
import { Navigate } from 'react-router';
import * as C from './constants';

const SiteDTLBrowser = lazy(() => import('../Container/SiteDTLBrowser'));
const TemplateBrowser = lazy(() => import('../Container/TemplateBrowser'));
const ViewManage = lazy(() => import('../Container/ViewManage'));
const InititateDtlTemplate = lazy(() => import('../Container/InititateDtlTemplate'));
const CloneTemplate = lazy(() => import('../Container/CloneTemplate'));
const TaskAssignmentBrowser = lazy(() => import('../Container/TaskAssignmentBrowser'));
const ViewManageDtl = lazy(() => import('../Container/SiteDtl/ViewManage'));
const InititateNewDtl = lazy(() => import('../Container/SiteDtl/InititateNewDtl'));
const CloneDtlContainer = lazy(() => import('../Container/SiteDtl/Clone'));
const ConfirmationContainer = lazy(() => import('../Container/SiteDtl/Confirmation'));
const ApprovalContainer = lazy(() => import('../Container/SiteDtl/Approval'));
const ManageTasksContainer = lazy(() => import('../Container/TaskAssignment/ManageTasks'));
const AssignTasksComponent = lazy(() => import('../components/TAB/AssignTasks'));
const InactivateTasksComponent = lazy(() => import('../components/TAB/InactivateTasks'));
const RequestBrowser = lazy(() => import('../Container/RequestBrowser'));
const ProcessIdpRequest = lazy(() => import('../Container/ProcessIdpRequest'));
const DashboardContainer = lazy(() => import('../Container/DashboardContainer'));
const ProcessDefaultPage = lazy(() => import('../Container/ProcessDefaultPage')); 
const SubmitContainer = lazy(() => import('../Container/SiteDtl/Submit'));
const UpcomingContainer = lazy(() => import('../Container/SiteDtl/Upcoming'));

const appRoutes = [
  {
    path: C.DASHBOARD_PATH,
    name: 'Dashboard',
    title: 'Dashboard',
    isExact: true,
    showInMenu: true,
    isAvailable: true,
    element: <DashboardContainer />,
    condition: ['SITE'],
    permission: 'dtl.dashboard.view',
    helpContext: 'dashboard'
  },
  {
    path: C.TEMPLATE_PATH,
    name: 'Template',
    title: 'Template',
    isExact: true,
    showInMenu: true,
    isAvailable: true,
    condition: ['LPO', 'NCI', 'CTSU', 'CTMS'],
    element: <Navigate to={C.TEMPLATE_BROWSER_PATH} replace={true} />,
    permission: 'dtl.template.browser',
    helpContext: 'TemplateBrowser',
    subRoutes: [
      {
        path: C.TEMPLATE_BROWSER_PATH,
        name: 'Browser',
        title: 'Template Browser',
        isExact: true,
        showInMenu: true,
        isAvailable: true,
        condition: ['LPO', 'NCI', 'CTSU', 'CTMS'],
        isNewTab: false,
        element: <TemplateBrowser />,
        helpContext: 'TemplateBrowser',
        permission: 'dtl.template.browser'
      },
      {
        path: C.INITITATE_DTL_TEMPLATE_PATH,
        name: 'Initiate DTL Template',
        title: 'Initiate DTL Template',
        isExact: true,
        showInMenu: false,
        isAvailable: true,
        condition: ['LPO', 'NCI', 'CTSU', 'CTMS'],
        element: <InititateDtlTemplate />,
        subRoutes: [],
        permission: 'dtl.template.browser',
        helpContext: 'initiate-dtl-template'
      },
      {
        path: C.MANAGE_TEMPLATE_PATH_PARAM,
        name: 'Manage Template',
        title: 'Manage Template',
        isExact: true,
        showInMenu: false,
        element: <ViewManage />,
        isAvailable: true,
        condition: ['LPO', 'NCI', 'CTSU', 'CTMS'],
        subRoutes: [],
        permission: 'dtl.template.browser',
        helpContext: 'manage-dtl-template'
      },
      {
        path: C.CLONE_TEMPLATE_PATH_PARAM,
        name: 'Clone DTL Template',
        title: 'Clone DTL Template',
        isExact: true,
        showInMenu: false,
        element: <CloneTemplate />,
        isAvailable: true,
        condition: ['LPO', 'NCI', 'CTSU', 'CTMS'],
        subRoutes: [],
        permission: 'dtl.template.clone',
        helpContext: 'clone-dtl-template'
      }
    ]
  },
  {
    path: C.SITE_DTL_PATH,
    name: 'Site DTL',
    title: 'Site DTL',
    isExact: true,
    showInMenu: true,
    isAvailable: true,
    element: <Navigate to={C.SITE_DTL_BROWSER_PATH} replace={true} />,
    permission: 'dtl.site.browser',
    helpContext: 'sitedtl-browser',
    subRoutes: [
      {
        path: C.SITE_DTL_BROWSER_PATH,
        name: 'Browser',
        title: 'Site DTL Browser',
        isExact: true,
        showInMenu: true,
        isNewTab: false,
        isAvailable: true,
        element: <SiteDTLBrowser />,
        permission: 'dtl.site.browser',
        helpContext: 'sitedtl-browser'
      },
      {
        path: C.MANAGE_SITE_DTL_PATH_PARAM,
        name: 'Manage Site DTL',
        title: 'Manage Site DTL',
        isExact: true,
        showInMenu: false,
        element: <ViewManageDtl />,
        isAvailable: true,
        subRoutes: [],
        permission: 'dtl.site.view',
        helpContext: 'manage-sitedtl'
      },
      {
        path: C.INITITATE_NEW_DTL_PATH,
        name: 'Initiate New Site DTL',
        title: 'Initiate New Site DTL',
        isExact: true,
        showInMenu: false,
        isAvailable: true,
        element: <InititateNewDtl />,
        subRoutes: [],
        permission: 'dtl.site.new',
        helpContext: 'initiate-sitedtl'
      },
      {
        path: C.CLONE_SITE_DTL_PATH,
        name: 'Clone DTLs',
        title: 'Clone DTLs',
        isExact: true,
        showInMenu: true,
        isAvailable: true,
        element: <CloneDtlContainer />,
        condition: ['SITE'],
        permission: 'dtl.site.clone',
        helpContext: 'clone-sitedtl',
        subRoutes: []
      },
      {
        path: C.REQUEST_CLONE_CONFIRMATION_PATH,
        name: 'Request Clone Confirmation',
        title: 'Request Clone Confirmation',
        isExact: true,
        showInMenu: false,
        isAvailable: true,
        element: <ConfirmationContainer />,
        condition: ['SITE'],
        permission: 'dtl.site.clone',
        helpContext: 'clone-sitedtl',
        subRoutes: []
      },
      {
        path: C.SUBMIT_SITE_DTL_PATH,
        name: 'Submit for Approval',
        title: 'Submit for Approval',
        isExact: true,
        showInMenu: true,
        isAvailable: true,
        element: <SubmitContainer />,
        condition: ['SITE'],
        permission: 'dtl.site.submit',
        helpContext: 'submit-sitedtl',
        subRoutes: []
      },
      {
        path: C.REQUEST_SUBMIT_CONFIRMATION_PATH,
        name: 'Submit for Approval Confirmation',
        title: 'Submit for Approval Confirmation',
        isExact: true,
        showInMenu: false,
        isAvailable: true,
        element: <ConfirmationContainer />,
        condition: ['SITE'],
        permission: 'dtl.site.submit',
        helpContext: 'submit-sitedtl',
        subRoutes: []
      },
      {
        path: C.APPROVAL_SITE_DTL_PATH,
        name: 'DTL Approvals',
        title: 'DTL Approvals',
        isExact: true,
        showInMenu: true,
        isAvailable: true,
        element: <ApprovalContainer />,
        condition: ['SITE'],
        permission: 'dtl.site.approve',
        helpContext: 'approve-sitedtl',
        subRoutes: []
      },
      {
        path: C.REQUEST_APPROVE_CONFIRMATION_PATH,
        name: 'Request Approval Confirmation',
        title: 'Request Approval Confirmation',
        isExact: true,
        showInMenu: false,
        isAvailable: true,
        element: <ConfirmationContainer />,
        condition: ['SITE'],
        permission: 'dtl.site.approve',
        helpContext: 'approve-sitedtl',
        subRoutes: []
      },
      {
        path: C.UPCOMING_DTL_PATH,
        name: 'Available and Upcoming DTLs',
        title: 'Available and Upcoming DTLs',
        isExact: true,
        showInMenu: true,
        isAvailable: true,
        element: <UpcomingContainer />,
        permission: 'dtl.site.upcoming.browser',
        helpContext: 'upcoming-sitedtl',
        subRoutes: []
      }
    ]
  },
  {
    path: C.TASK_ASSIGNMENT_PATH,
    name: 'Task Assignment',
    isExact: true,
    showInMenu: true,
    isAvailable: true,
    element: <Navigate to={C.TASK_ASSIGNMENT_BROWSER_PATH} replace={true} />,
    permission: 'dtl.site.taskassigment.browser',
    helpContext: 'task-assignment-browser',
    subRoutes: [
      {
        path: C.TASK_ASSIGNMENT_BROWSER_PATH,
        name: 'Browser',
        title: 'Task Assignment Browser',
        isExact: true,
        showInMenu: true,
        isNewTab: false,
        isAvailable: true,
        element: <TaskAssignmentBrowser />,
        permission: 'dtl.site.taskassigment.browser',
        helpContext: 'task-assignment-browser'
      },
      {
        path: C.MANAGE_TASKS_PATH,
        name: 'Manage Tasks',
        title: 'Manage Tasks',
        isExact: true,
        showInMenu: true,
        isAvailable: true,
        element: <ManageTasksContainer />,
        condition: ['SITE'],
        permission: 'dtl.site.edit',
        helpContext: 'manage-tasks'
      },
      {
        path: C.ASSIGN_TASKS_PATH,
        name: 'Assign Tasks',
        title: 'Assign Tasks',
        isExact: true,
        showInMenu: false,
        isAvailable: true,
        element: <AssignTasksComponent />,
        condition: ['SITE'],
        permission: 'dtl.site.edit',
        helpContext: 'manage-tasks-assign'
      },
      {
        path: C.REQUEST_ASSIGN_CONFIRMATION_PATH,
        name: 'Request Assign Confirmation',
        title: 'Request Assign Confirmation',
        isExact: true,
        showInMenu: false,
        isAvailable: true,
        element: <ConfirmationContainer />,
        condition: ['SITE'],
        permission: 'dtl.site.edit',
        helpContext: 'manage-tasks-assign',
        subRoutes: []
      },
      {
        path: C.INACTIVATE_TASKS_PATH,
        name: 'Inactivate Tasks',
        title: 'Inactivate Tasks',
        isExact: true,
        showInMenu: false,
        isAvailable: true,
        element: <InactivateTasksComponent />,
        condition: ['SITE'],
        permission: 'dtl.site.edit',
        helpContext: 'manage-tasks-inactivate'
      }, 
      {
        path: C.REQUEST_INACTIVATE_CONFIRMATION_PATH,
        name: 'Request Inactivate Confirmation',
        title: 'Request Inactivate Confirmation',
        isExact: true,
        showInMenu: false,
        isAvailable: true,
        element: <ConfirmationContainer />,
        condition: ['SITE'],
        permission: 'dtl.site.edit',
        helpContext: 'manage-tasks-inactivate',
        subRoutes: []
      }
    ]
  },
  {
    path: C.REQUEST_DTL_PATH,
    name: 'Request',
    title: 'Request',
    isExact: true,
    showInMenu: true,
    isAvailable: true,
    element: <Navigate to={C.REQUEST_BROWSER_PATH} replace={true} />,
    condition: ['SITE', 'NCI', 'CTSU'],
    permission: 'dtl.request.browser',
    helpContext: 'request-browser',
    subRoutes: [
      {
        path: C.REQUEST_BROWSER_PATH,
        name: 'Browser',
        title: 'Request Browser',
        isExact: true,
        showInMenu: true,
        isNewTab: false,
        isAvailable: true,
        element: <RequestBrowser />,
        condition: ['SITE', 'NCI', 'CTSU'],
        permission: 'dtl.request.browser',
        helpContext: 'request-browser'
      }
    ]
  }, 
  {
    path: C.PROCESS_IDP_REQUEST,
    name: 'Process Idp Request',
    title: 'Process Idp Request',
    isExact: true,
    showInMenu: false,
    isAvailable: true,
    element: <ProcessIdpRequest />,
    permission: 'dtl.site.browser',
    helpContext: 'process-idp-browser'
  }, 
  {
    path: C.DEFAULT_REQUEST,
    name: 'Default Page',
    title: 'Default Page',
    isExact: true,
    showInMenu: false,
    isAvailable: true,
    element: <ProcessDefaultPage />,
    permission: 'dtl.default.request',
    helpContext: 'process-default-request'
  }
];
export default appRoutes;
